import CloseIcon from '@mui/icons-material/Close';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Drawer,
  IconButton,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import useThemesCategoriesDrawerFilters, {
  ThemesCategoriesFilterDraft,
} from './themes-categories-drawer-filters.hook';

type ThemesCategoriesDrawerFiltersProps = {
  listLabel: 'Temas' | 'Categorias';
  isOpen: boolean;
  onClose: () => void;
  onApplyFilters: (filters: ThemesCategoriesFilterDraft) => void;
  appliedFilters: ThemesCategoriesFilterDraft | null;
};

export default function ThemesCategoriesDrawerFilters({
  listLabel,
  isOpen,
  onClose,
  onApplyFilters,
  appliedFilters,
}: ThemesCategoriesDrawerFiltersProps) {
  const hook = useThemesCategoriesDrawerFilters({
    isOpen,
    onClose,
    onApplyFilters,
    appliedFilters,
  });

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      anchor="right"
      PaperProps={{
        sx: {
          width: { xs: '100vw', sm: 560, md: 620 },
          maxWidth: '100vw',
          backgroundColor: 'grey.50',
        },
      }}
    >
      <Stack sx={{ height: '100%' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: 2.5, py: 2, borderBottom: '1px solid', borderColor: 'divider' }}
        >
          <Box>
            <Typography variant="h6" fontWeight={700}>
              Filtros de {listLabel}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Refine a listagem com os critérios desejados
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <Box sx={{ flex: 1, overflowY: 'auto', p: 2.5 }}>
          <Card
            variant="outlined"
            sx={{ borderRadius: 2.5, boxShadow: 'none', borderColor: 'grey.200' }}
          >
            <CardContent>
              <Stack spacing={2}>
                <Typography variant="subtitle1" fontWeight={700}>
                  Status
                </Typography>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={hook.statusOptions}
                  value={hook.statusOptions.filter((option) =>
                    hook.draftFilters.status.includes(option.value)
                  )}
                  onChange={(_, selected) =>
                    hook.handleChangeStatus(selected.map((item) => item.value))
                  }
                  getOptionLabel={(option) => option.label}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.value}
                        label={option.label}
                        size="small"
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField {...params} variant="filled" label="Status" />
                  )}
                />
              </Stack>
            </CardContent>
          </Card>
        </Box>

        <Divider />
        <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={{ p: 2.5 }}>
          <Button variant="outlined" onClick={hook.handleClear}>
            Limpar
          </Button>
          <Button variant="contained" onClick={hook.handleApply}>
            Aplicar filtros
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}
